import { useEffect, useState } from "react";
import { useTemplateContext } from "../../../context/TemplateContext";
import Loader from "../../../Layouts/Loader/Loader";
import ErrorMessage from "../../../components/FormComponents/ErrorMessage";
import axiosInstance, { handleApiError } from "../../../services/axiosService";
import AiAssistantEditor from "./AiAssistantEditor";

const AiAssistantTemplateViewer = ({ file }) => {
  const { templateData, setTemplateData } = useTemplateContext();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchTemplate = async () => {
      try {
        setIsLoading(true);
        const res = await axiosInstance.get(`/ai-assistant-template/${file.id}`);
        setTemplateData(res.data);
      } catch (err) {
        setError("Failed to load AI Assistant template.");
        handleApiError(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchTemplate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [file.id]);

  if (isLoading) return <Loader />;
  if (error)
    return (
      <div className="d_flex justify_center align_center h_100">
        <ErrorMessage>{error}</ErrorMessage>
      </div>
    );

  if (!templateData) return null;

  return <AiAssistantEditor file={file} templateData={templateData} setTemplateData={setTemplateData} />;
};

export default AiAssistantTemplateViewer;
